<ng-container *ngIf="cards; else loadingCarousel">
  <ng-container *ngIf="cards.length; else noCards">
    <swiper *ngIf="cards.length > 1; else uniqueCard" [config]="config" class="block">
      <ng-container *ngFor="let card of cards">
        <ng-template swiperSlide>
          <mom-carousel-card [card]="card" (continue)="continue.emit(card)"></mom-carousel-card>
        </ng-template>
      </ng-container>
    </swiper>
    <ng-template #uniqueCard>
      <mom-carousel-card [card]="cards[0]" (continue)="continue.emit(cards[0])"></mom-carousel-card>
    </ng-template>
  </ng-container>
  <ng-template #noCards>
    <mom-carousel-empty></mom-carousel-empty>
  </ng-template>
</ng-container>

<ng-template #loadingCarousel>
  <!-- TODO: Set number of skeleton based on device width -->
  <swiper [config]="config">
    <ng-template swiperSlide>
      <mom-carousel-card-skeleton></mom-carousel-card-skeleton>
    </ng-template>
    <ng-template swiperSlide>
      <mom-carousel-card-skeleton></mom-carousel-card-skeleton>
    </ng-template>
  </swiper>
</ng-template>
